<template>
  <div v-if="!chunkFailed">
    <div v-if="loggedIn">
      <DashboardPage
          :request="request"
          :logged-in="loggedIn"
          :loading="loading"
          :user-data="userData"
          :icons="icons"
      />
    </div>
    <div v-else>
<!--      <GuestPage  :icons="icons"/>-->
      <LoginPage  :icons="icons" :cache="cache" :request="request"/>
    </div>
  </div>
</template>
<script>
import {IconsUI} from "@/utils/IconsUI";
import LoginPage from "@/pages/LoginPage.vue";
import DashboardPage from "@/pages/DashboardPage.vue";
import RequestManager from "@/utils/RequestManager";
import CacheManager from "@/utils/CacheManager";

export default {
  name: "HomePage",
  components: {LoginPage, DashboardPage},
  props: {
    icons: {type: IconsUI, required: true},
    userData: {type: Object, required: true},
    loading: {type: Boolean, required: true},
    loggedIn: {type: Boolean, required: true},
    cache: {type: CacheManager, required: true},
    chunkFailed: {type: Boolean, required: true},
    request: {type: RequestManager, required: true},
  }
}
</script>
